module.exports = __webpack_public_path__ + "img/inge-v6-char-5.3ed2c9b2.png";